import React, { useContext, useEffect } from 'react';
import ReservationList from './ReservationList';
import { RouteComponentProps } from 'react-router-dom';
import { Modify } from 'utils/types';
import { ReservationContext } from 'Contexts/ReservationContext';
import { AuthContext } from 'Contexts/AuthContext';

export type ReservationListContainerProps = Modify<
  RouteComponentProps,
  {
    match: { params: { date: string; restaurantId: string } };
  }
>;

const ReservationListContainer: React.FC<ReservationListContainerProps> = ({
  history,
  match,
}) => {
  const { date, restaurantId } = match.params;

  const { setrestaurantId } = useContext(AuthContext);
  const { setdate } = useContext(ReservationContext);

  const onDateChange = (newDate: string) =>
    history.push(`/${restaurantId}/reservations/${newDate}/list`);

  useEffect(() => {
    setdate(match.params.date);
    setrestaurantId(restaurantId);
  }, [match.params, setdate]);

  useEffect(() => {
    let el = document.getElementsByTagName('body')[0];
    let root = document.documentElement;

    el.classList.add('hideOverflow');
    el.classList.add('tableplanscreen');
    root.classList.add('tableplan-scroll-lock');
    return () => {
      el.classList.remove('hideOverflow');
      el.classList.remove('tableplanscreen');
      root.classList.remove('tableplan-scroll-lock');
    };
  }, []);

  return <ReservationList {...{ date, restaurantId, onDateChange }} />;
};

export default ReservationListContainer;
